import { render, staticRenderFns } from "./ChatRoomCreation.vue?vue&type=template&id=5fc40478&"
import script from "./ChatRoomCreation.vue?vue&type=script&lang=js&"
export * from "./ChatRoomCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/domain/chat/chat_room_creation.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fyurinascimento%2FDocuments%2FWork%2Ftristar%2Ftristar-courier-frontend%2Fsrc%2Fdomain%2Fchat%2FChatRoomCreation.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/i18n/form.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2FUsers%2Fyurinascimento%2FDocuments%2FWork%2Ftristar%2Ftristar-courier-frontend%2Fsrc%2Fdomain%2Fchat%2FChatRoomCreation.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports